
export default function (Alpine) {
    Alpine.store('imageZoom', {
        isOpen: false,
        src: '',
        originalEl: null,
        
        open(el) {
            this.src = el.src;
            this.originalEl = el;
            this.isOpen = true;
            document.body.style.overflow = 'hidden';
            window.dispatchEvent(new CustomEvent('image-zoom-opened'));
        },
        
        close(e) {
            this.isOpen = false;
            document.body.style.overflow = '';
            this.originalEl = null;
            if (e && e.preventDefault) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    });

    Alpine.directive('image-zoom', (el, { expression }, { cleanup }) => {
        el.style.cursor = 'zoom-in';
        
        const iconContainer = document.createElement('div');
        iconContainer.className = 'absolute bottom-2 right-2 p-1.5 bg-white/50 backdrop-blur-sm rounded-lg text-white transition-opacity duration-300 cursor-pointer z-10';
        iconContainer.innerHTML = `
            <svg class="w-4 h-4" stroke="currentColor" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 8V4M4 4H8M4 4L9 9M20 8V4M20 4H16M20 4L15 9M4 16V20M4 20H8M4 20L9 15M20 20L15 15M20 20V16M20 20H16" stroke="#1E2939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;

        const parent = el.parentElement;
        if (parent) {
            parent.style.position = 'relative';
            parent.appendChild(iconContainer);
        }
        
        const clickHandler = (e) => {
            e.preventDefault();
            e.stopPropagation();
            Alpine.store('imageZoom').open(el);
        };

        el.addEventListener('click', clickHandler);
        iconContainer.addEventListener('click', clickHandler);

        cleanup(() => {
            el.removeEventListener('click', clickHandler);
            iconContainer.removeEventListener('click', clickHandler);
            if (iconContainer.parentNode) {
                iconContainer.parentNode.removeChild(iconContainer);
            }
        });
    });
}
